import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface PropTypes {
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  icon: React.ReactNode;
  label: string;
  className?: string;
}
const ButtonWithLabel: React.FC<PropTypes> = t0 => {
  const $ = _c(7);
  const {
    label,
    icon,
    className,
    onClick
  } = t0;
  const t1 = `flex flex-col items-center justify-center hover:opacity-[0.5] ${className}`;
  let t2;
  if ($[0] !== label) {
    t2 = <span className="text-white mt-1">{label}</span>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== icon || $[3] !== onClick || $[4] !== t1 || $[5] !== t2) {
    t3 = <button className={t1} onClick={onClick}>{icon}{t2}</button>;
    $[2] = icon;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ButtonWithLabel;